import React from 'react';

const avatarColors = [
  'bg-violet-500',
  'bg-success-500',
  'bg-pink-500',
  'bg-amber-500',
  'bg-secondary-500',
];
const getAvatarColor = (seed: string) =>
  avatarColors[(seed.charCodeAt(0) || 0) % avatarColors.length];
const getInitials = (first: string, last: string) =>
  `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase() || '?';

export interface LeaderboardEntry {
  rank: number;
  membershipId: string;
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
  /** Current points balance — what the board is ranked by. */
  points: number;
}

const LeaderboardRow: React.FC<{ entry: LeaderboardEntry }> = ({ entry }) => {
  const name = `${entry.firstName} ${entry.lastName}`.trim() || '—';

  return (
    <tr className="border-b border-border-primary/60 transition-colors hover:bg-background-secondary/40">
      <td className="px-6 py-3.5 w-16 body-small font-semibold tabular-nums text-text-secondary">
        {entry.rank}
      </td>
      <td className="px-4 py-3.5">
        <div className="flex items-center gap-3">
          {entry.avatarUrl ? (
            <img
              src={entry.avatarUrl}
              alt={name}
              className="h-9 w-9 flex-shrink-0 rounded-full object-cover"
            />
          ) : (
            <div
              className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white ${getAvatarColor(
                name
              )}`}
            >
              {getInitials(entry.firstName, entry.lastName)}
            </div>
          )}
          <p className="body-small max-w-[220px] truncate font-semibold text-text-primary">
            {name}
          </p>
        </div>
      </td>
      <td className="px-4 py-3.5 text-right body-small font-semibold tabular-nums text-text-primary">
        {entry.points.toLocaleString()}
      </td>
    </tr>
  );
};

export default LeaderboardRow;
